import { useEffect, useState } from "react";
import type { Episode } from "@/mocks/movies";

interface EpisodeListProps {
  episodes: Episode[];
  totalEpisodes?: number;
  status: string;
}

export default function EpisodeList({ episodes, totalEpisodes, status }: EpisodeListProps) {
  const [activeNo, setActiveNo] = useState(episodes[0]?.no ?? 1);
  const active = episodes.find((item) => item.no === activeNo) ?? episodes[0];

  useEffect(() => {
    setActiveNo(episodes[0]?.no ?? 1);
  }, [episodes]);

  if (episodes.length === 0) return null;

  return (
    <section className="mt-8 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5" aria-label="剧集目录">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-background-200 pb-3">
        <h2 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
          <i className="ri-play-list-2-line text-accent-500" aria-hidden="true" />
          剧集目录
        </h2>
        <p className="text-xs text-foreground-400">
          {status}
          {totalEpisodes ? ` · 共 ${totalEpisodes} 集，本页展示前 ${episodes.length} 集` : ""}
        </p>
      </div>

      <div className="mt-3 grid grid-cols-4 gap-2 sm:grid-cols-6 md:grid-cols-8">
        {episodes.map((episode) => (
          <button
            key={episode.no}
            type="button"
            onClick={() => setActiveNo(episode.no)}
            className={`cursor-pointer rounded-md border px-2 py-2 text-xs transition-colors ${
              episode.no === activeNo
                ? "border-primary-500 bg-primary-500 font-semibold text-background-50"
                : "border-background-200 bg-background-100 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            第 {episode.no} 集
          </button>
        ))}
      </div>

      {active && (
        <div className="mt-4 rounded-md bg-background-100 p-4">
          <div className="flex flex-wrap items-center gap-2">
            <span className="rounded bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-700">
              第 {active.no} 集
            </span>
            <h3 className="font-heading text-sm font-semibold text-foreground-950">{active.title}</h3>
            <span className="flex items-center gap-1 text-[11px] text-foreground-400">
              <i className="ri-time-line" aria-hidden="true" />
              {active.duration}
            </span>
          </div>
          <p className="mt-2 text-sm leading-7 text-foreground-600">{active.synopsis}</p>
          <p className="mt-2 text-[11px] text-foreground-400">
            <i className="ri-information-line mr-1" aria-hidden="true" />
            本站为演示站点，不提供剧集播放，剧集信息仅用于内容展示。
          </p>
        </div>
      )}
    </section>
  );
}